import React, { useEffect, useState } from 'react';

const API_KEY = 'f8b3da4e7a7049799e876d10e50103e9';

const SignalHistoryBox = ({ symbol }) => {
  const [data, setData] = useState(null);
  const [lastFetched, setLastFetched] = useState(null);

  useEffect(() => {
    if (!symbol) return;

    const fetchData = () => {
      const cleanSymbol = symbol
  .replace('OANDA:', '')
  .replace('BINANCE:', '')
  .replace('NASDAQ:', '')
  .replace('NYSE:', '')
  .replace('NSE:', '')
  .replace('TVC:', '')
  .replace('DJ:', '')
  .replace('SP:', '')
  .replace(/[^A-Z/]/g, '') // strip anything unnecessary

const finalSymbol = cleanSymbol.includes('/') ? cleanSymbol : cleanSymbol.slice(0, 3) + '/' + cleanSymbol.slice(3);

fetch(`https://api.twelvedata.com/quote?symbol=${finalSymbol}&apikey=${API_KEY}`)

        .then(res => res.json())
        .then(res => {
          if (!res.status || res.status !== "error") {
            setData(res);
            setLastFetched(new Date().toLocaleTimeString());
          }
        })
        .catch(err => console.error("Error fetching signal:", err));
    };

    fetchData(); // Run on first mount
    const interval = setInterval(fetchData, 30000); // Refresh every 30 sec

    return () => clearInterval(interval);
  }, [symbol]);

  const interpretSignal = () => {
    if (!data || !data.percent_change) return "Neutral";

    const pct = parseFloat(data.percent_change);
    if (pct > 0.3) return "Buy";
    if (pct < -0.3) return "Sell";
    return "Neutral";
  };

  return (
    <div className="bg-black rounded-lg shadow p-4 mt-6">
      <h3 className="text-md font-semibold mb-2">📡 Live Signal from API</h3>
      {data ? (
        <div className="text-sm space-y-1">
          <div><strong>Symbol:</strong> {data.symbol}</div>
          <div><strong>Last Price:</strong> {data.close}</div>
          <div><strong>Change:</strong> {data.change} ({data.percent_change}%)</div>
          <div><strong>Signal:</strong> <span className="font-bold">{interpretSignal()}</span></div>
          <div className="text-gray-500 text-xs">Updated: {lastFetched}</div>
        </div>
      ) : (
        <div className="text-gray-400 text-sm">Loading signal data...</div>
      )}
    </div>
  );
};

export default SignalHistoryBox;
